import { useEffect, useState } from 'react'
import styles from './MarketingStockSetWrapper.module.css'
import {MarketingStockProduct} from "../../MarketingStockProduct/MarketingStockProduct"
import {useCartContext} from "../../../../Context/CartContext";
import {Button} from "primereact/button";
import {MarketingStockProductMobileView} from "../../MarketingStockProduct/MarketingStockProductMobileView";
import { Tag } from 'primereact/tag';


export const MarketingStockSetWrapper = ({setListWithProduct, stockId, stockModel, toast}) =>{
    const {addStockProductSetToCart, removeStockSetItemFromCart} = useCartContext();
    const addSetToCartHandler = async(setId) => {
        addStockProductSetToCart(stockId, stockModel.Name, setId).then((data) => {
            if (data.isSucccess) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Комплект додано у кошик',
                    clearPrevious: true,
                    life: 1000
                });
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка',
                    clearPrevious: true,
                    detail: 'Помилка змінення кошика',
                    life: 1000
                });
            }
        })
    }

    const removeStockSetItemHandler = async(stockId, setId) => {
        removeStockSetItemFromCart(stockId, setId).then((data) => {
            if (data.isSucccess) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Комплект видалено з кошика',
                    clearPrevious: true,
                    life: 1000
                });
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка',
                    clearPrevious: true,
                    detail: 'Помилка змінення кошика',
                    life: 1000
                });
            }
        })
    }

    return (

        <div>
            {setListWithProduct.length ?
            setListWithProduct.map((setItem, index) =>
            <div className={styles.productSetWrapper} key={setItem.Id + index}>
                <div className={styles.setName}>
                    <h5>{setItem.Name}</h5>
                    <Tag severity="info" value="Комплект" rounded></Tag>
                </div>

                <div className={styles.productsWrapper} style={{position:'relative'}}>
                    {setItem.ProductList.map((productItem, index) =>
                        <MarketingStockProductMobileView
                        key={productItem.ProductName + productItem.ProductNumber + index}
                        id={productItem.Id}
                        isSet={true}
                        productCountFromList={setItem.ProductList.length}
                        index={index}
                        stockId={stockId}
                        stockName={stockModel.Name}
                        productNumber={productItem.ProductNumber}
                        productName={productItem.ProductName}
                        reccomendPrice={productItem.ReccomendPrice}
                        volume={productItem.Volume}
                        totalBalance={productItem.TotalBalance}
                        totalAmount={productItem.TotalAmount}
                        smallImageUrl={productItem.SmallImageUrl}
                        originalImageUrl={productItem.OriginalImageUrl}
                        productPrice={productItem.ProductPrice}
                        productStockPrice={productItem.ProductStockPrice}
                        productPriceList={productItem.ProductPriceList}
                        toast={toast}
                    />
                    )}
                </div>

                <div className={styles.buttons}>
                    <Button label="Додати комплект в кошик" rounded style={{fontFamily:'Commissioner', color:'#404040', borderRadius:'0px 0px 0px 15px' }} onClick={() => addSetToCartHandler(setItem.Id)} />
                    {setItem.isPresentIsCart ? <Button label="Видалити комплект з кошика"  severity="danger" style={{fontFamily:'Commissioner', borderRadius:'0px 0px 15px 0px' }} onClick={() => removeStockSetItemHandler(stockId, setItem.Id)} /> : <div></div>}
                </div>
            </div>
            )
            :
            null}
        </div>
    )
}